import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import type { ModuleIdType } from '../types.js'
import type { BusinessObjectIdType } from '../types.js'
import type { UserIdType } from '../types.js'
import { UserIdCtor } from '../user-id.js'
import {
	jsonProperty,
	jsonArrayProperty,
	jsonClass,
} from '@sumbricht/json-class-serializer'

@jsonClass('UserRole')
export class UserRole {
	@jsonProperty(Number)
	id?: number

	@jsonProperty(() => UserIdCtor)
	userId?: UserIdType

	@jsonProperty(String)
	roleModuleId: ModuleIdType = ''

	@jsonProperty(String)
	roleBoId: BusinessObjectIdType = ''

	@jsonArrayProperty(String)
	tenantIds: string[] = []
	@jsonProperty(Boolean)
	appliesAlsoToSubTenants: boolean = true

	constructor(init?: Partial<UserRole>) {
		assignCommonProperties(this, init)
	}

	static fromQualifiedName(qualifiedName: string) {
		const [roleModuleId, roleBoId] = qualifiedName.split('.')
		return new UserRole({ roleModuleId, roleBoId })
	}

	getQualifiedTypeAndName() {
		return `Role:${this.getQualifiedName()}`
	}

	getQualifiedName() {
		return `${this.roleModuleId}.${this.roleBoId}`
	}

	matches(other: UserRole) {
		return (
			this.roleModuleId === other.roleModuleId &&
			this.roleBoId === other.roleBoId
		)
	}
}

@jsonClass('UserIdpRole')
export class UserIdpRole extends UserRole {
	@jsonProperty(String)
	identityProviderId?: string

	constructor(init?: Partial<UserIdpRole>) {
		super()
		assignCommonProperties(this, init)
	}

	static fromQualifiedNameAndProviderId(
		qualifiedName: string,
		identityProviderId: string,
	) {
		const [roleModuleId, roleBoId] = qualifiedName.split('.')
		return new UserIdpRole({ roleModuleId, roleBoId, identityProviderId })
	}
}
